import React from 'react';
import {LessonContentVideoBackgorund} from '../../../../../data/models/LessonContent/LessonContentBase';
import {lessonEditorText} from '../../../lessonEditorText';
import VideoBackgorundOptionsUI from '../view/VideoBackgroundOptionsUI';
import BaseOptionsContainer, {
  BaseContainerProps,
} from '../../BaseOptionsContainer';

export default React.memo((props: BaseContainerProps) => (
  <BaseOptionsContainer
    {...props}
    deleteMessage={lessonEditorText.areYouSureDeleteVideoBackgorundOption}>
    {forwardProps => (
      <VideoBackgorundOptionsUI
        {...forwardProps}
        entityToEdit={forwardProps.entityToEdit as LessonContentVideoBackgorund}
      />
    )}
  </BaseOptionsContainer>
));
